import CacheManage from './src/main'

export default CacheManage



// WEBPACK FOOTER //
// ./src/views/question-review/components/CacheManage/index.js